'use client';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { CMSSteps } from '@/api/cms/restrictions';
import { ImageComponent } from '@/components/Image';
import { useMatchingSection } from '@/modules/restrictions/hooks/useAccessSection';
import {
  ScHowToParticipateSection,
  ScHowToParticipateSectionCard,
  ScHowToParticipateSectionTitle,
} from './styled';

interface HowToParticipateSectionProps {
  label?: string;
  hideDescription?: boolean;
  sections: CMSSteps[];
}

export const HowToParticipateSection: FC<HowToParticipateSectionProps> = ({
  label,
  hideDescription,
  sections,
}) => {
  const { t } = useTranslation('promotions');
  const section = useMatchingSection(sections);
  const cards = section?.items;

  if (!cards) return null;

  return (
    <ScHowToParticipateSection>
      <ScHowToParticipateSectionTitle>
        {t('howToParticipate')}
      </ScHowToParticipateSectionTitle>
      <div className="cards">
        {cards.map(({ id, title, description }, index) => (
          <ScHowToParticipateSectionCard key={id}>
            <ImageComponent
              alt="step card"
              className="image"
              fill
              src="/scratchGame/htp-bg.webp"
            />
            <p className="title">{title}</p>
            {!hideDescription && description && (
              <p className="description">{description}</p>
            )}
            {label && index === 0 && <p className="label">{label}</p>}
          </ScHowToParticipateSectionCard>
        ))}
      </div>
    </ScHowToParticipateSection>
  );
};
